import {DomainEvent} from './DomainEvent';
import type {EntityExportRequest} from './EntityExportRequest';

export interface CupTeamSeasonsExportRequest extends EntityExportRequest {
  /** whether only relations of active or only inactive competition seasons shall be exported, defaults to all relations */
  readonly active?: boolean;
  /** the id of the club of which to export the related team seasons, defaults to all team seasons */
  readonly clubId?: number;
  /** the id of the competition season of which to export the related team seasons, defaults to all team seasons */
  readonly competitionSeasonId?: number;
}

/**
 * This event can be fired to indicate that a service requires the relations of team seasons to cups, optionally with a specific active flag.
 * Another service that is eligible to provide this info will put batches of the requested models into
 * the specified S3 {@see CupTeamSeasonsExportRequest.targetBucket} using
 * the {@see CupTeamSeasonsExportRequest.transactionId} as prefix (sub-folder).
 */
export class CupTeamSeasonsExportRequested extends DomainEvent<CupTeamSeasonsExportRequest> {}
